define('PLPSorting',
  [
    'Facets.Browse.View',
    'underscore'
  ], function (
    FacetsBrowseView,
    _
  ) {
    'use strict';

    return {
      mountToApp: function mountToApp(container) {
        var PLP = container.getComponent('PLP');
        window.location.relevance = '';
        var orderText = 'order=';
        var wLocation, self, retVal;
        _.extend(FacetsBrowseView.prototype, {
          showContent: _.wrap(FacetsBrowseView.prototype.showContent, function (originalFn) {
            retVal = originalFn.apply(this, _.toArray(arguments).slice(1));
            wLocation = window.location;
            self = this;

            retVal.then(function () {
              if (PLP && !self.isCategoryPage && wLocation && wLocation.search.indexOf(orderText) === -1 && wLocation.hash.indexOf(orderText) === -1 && PLP.getSearchText() !== wLocation.relevance) {
                if (PLP.getAllSorting()) {
                  PLP.setSorting({ sorting: 'relevance:desc' });
                }
              } else {
                // remember my name so many searchs can be executed at the same time
                window.location.relevance = PLP.getSearchText();
              }
            });

            return retVal;
          })
        });
      }
    };
  });
